import React from 'react';

// this uses an expanded version of the SVG
export default props => (
  <svg {...props} viewBox="0 0 150 150">
    {props.children}
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="M143 103.5 75.3 64.3 7 103.6l68 39.2 68-39.3Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.86 6.86"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="M142.9 109.7 75 70.7 6.9 110l67.8 39 68.2-39.3Z"
    />
    <path
      fill="#fff"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m109.3 117.7-53-30.4V1l53 30.8v86Z"
    />
    <path
      fill="#cce6d7"
      fillRule="evenodd"
      d="m92.3 15.7 5.1-1.8c4.4-1.5 9.8-.3 15.1 4.1a46.6 46.6 0 0 1 15 40c-1.1 6.5-4.3 10.7-8.7 12.3l-5 1.8c4.3-1.5 7.5-5.7 8.7-12.4 2.3-13.2-4.4-31-15-39.9-5.4-4.4-10.8-5.6-15.2-4.1Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.5}
      d="M107.8 19.7c-5.3-4.4-10.6-5.6-14.8-4.2-4.2 1.5-7.5 5.6-8.6 12.3-1.2 6.6-.1 14.4 2.6 21.7 2.7 7.2 7 13.9 12.4 18.3s10.7 5.6 14.9 4.2c4.2-1.5 7.4-5.7 8.6-12.3 1.2-6.7 0-14.5-2.6-21.7a44 44 0 0 0-12.5-18.3Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M45.6 90.3V114l7.2-4.2V86.2l-7.2 4.1Z"
    />
    <path
      fill="#cce6d7"
      fillRule="evenodd"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M25.5 78.7 40 70.5l14.5 25-8.9-5.2V114l-11.8-7V83.5l-8.3-4.8Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m60.9 91.7-14.5-25-6.4 3.8 14.5 25 6.4-3.8Z"
    />
    <path
      fill="#fff"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M66.6 61.8 37 44.8V17.6l29.5 17.2v27Z"
    />
    <path d="M63.2 37.1 51 30v.8l12.3 7.1v-.8Zm0 9.2-12.3-7v.7l12.3 7.1v-.8Zm-.2-4.5-12-7v.7l12 7v-.8Z" />
    <path
      fill="#cce6d7"
      stroke="#15161a"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="m66.6 61.8 2.7-1.6-.1-27-2.6 1.7v27Z"
    />
    <path
      fill="#fff"
      stroke="#15161a"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="m66.6 34.9 2.6-1.7L39.6 16 37 17.6 66.6 35Z"
    />
    <path
      fill="none"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m98 122.8-29.5-17V75.2L98 92.4v30.3Z"
    />
    <path
      fill="#cce6d7"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m40.4 33.7 7.2 4.2v-9.2l-7.2-4.2v9.2Z"
    />
    <path fill="#cce6d7" d="m40.2 42.6 22.4 12.9v-5L40.2 37.8v4.9Z" />
    <path
      fill="#cce6d7"
      stroke="#cce6d7"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="m100 54.3-3 1.6 17.7-16.5 2.4-1.3-17 16.2Z"
    />
    <path
      fill="#cce6d7"
      stroke="#cce6d7"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="m114.6 33.4-2.5 1.2 2.6 4.9 2.4-1.3-2.5-4.8Zm-19.1 5L93 39.6l4.5 8.6 2-1.9-4-7.9Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m114.7 39.5-2.7-5-14.5 13.8-4.5-8.7-3.2 2.8L97 56l17.7-16.4Z"
    />
  </svg>
);
